import BaseComponent, { Component } from '@/mixins/base.component';

import WbHeader from '../header/header.vue';

@Component({
   components: { WbHeader },
} as any)
export default class NotFoundView extends BaseComponent {

   get notFoundReason(): string {
      return this.$store.state.shows.notFoundReason;
   }

   get isNotAvailable(): boolean {
      return this.notFoundReason === 'notAvailable';
   }

}
